import React, { useState } from "react";
import { FaArrowRight, FaSearch } from "react-icons/fa";
import { Link } from "react-router-dom";

const NavbarThree = () => {
  const [active, setActive] = useState(false);
  const [searchShow, setSearchShow] = useState(false);

  // NEW: dropdown state (which menu is open)
  const [openDropdown, setOpenDropdown] = useState(null); // "funding" | "accelerator" | null

  const menuActive = () => setActive((p) => !p);
  const searchActive = () => setSearchShow((p) => !p);

  const toggleDropdown = (key) => {
    setOpenDropdown((prev) => (prev === key ? null : key));
  };

  const closeDropdowns = () => {
    setOpenDropdown(null);
    setActive(false); // Close mobile menu when navigating
  };

  return (
    <>
      {/* search popup start*/}
      <div
        className={searchShow ? "td-search-popup active" : "td-search-popup "}
        id="td-search-popup"
      >
        <form action="/" className="search-form">
          <div className="form-group">
            <input type="text" className="form-control" placeholder="Search" />
          </div>
          <button type="submit" className="submit-btn">
            <FaSearch />
          </button>
        </form>
      </div>
      {/* search popup end*/}

      <div
        onClick={() => {
          searchActive();
          closeDropdowns();
        }}
        className={searchShow ? "body-overlay active" : "body-overlay"}
        id="body-overlay"
      />

      <nav className="navbar navbar-area navbar-area-4 navbar-expand-lg">
        <div className="container nav-container custom-container">
          <div className="responsive-mobile-menu">
            <button
              onClick={() => {
                menuActive();
                closeDropdowns();
              }}
              className={
                active
                  ? "menu toggle-btn d-block d-lg-none open"
                  : "menu toggle-btn d-block d-lg-none"
              }
              data-target="#itech_main_menu"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="icon-left" />
              <span className="icon-right" />
            </button>
          </div>

          <div className="logo">
            <Link to="/" onClick={closeDropdowns}>
              <p>
                <span style={{ color: "#414141" }}>Evolve</span>
                <span style={{ color: "#4faf9b" }}>Lab</span>
              </p>
            </Link>
          </div>

          <div className="nav-right-part nav-right-part-mobile">
            <span
              className="search-bar-btn"
              onClick={() => {
                searchActive();
                closeDropdowns();
              }}
            >
              <FaSearch />
            </span>
          </div>

          <div
            className={active ? "collapse navbar-collapse sopen" : "collapse navbar-collapse"}
            id="itech_main_menu"
          >
            <ul className="navbar-nav  menu-open text-lg-center ps-lg-5 navbarService">
              <li>
                <Link to="/" onClick={closeDropdowns}>Home</Link>
              </li>
              <li>
                <Link to="/about" onClick={closeDropdowns}>About</Link>
              </li>

              {/* ✅ NEW: Funding dropdown */}
              {/* FUNDING */}
              <li className={`menu-item-has-children ${openDropdown === "funding" ? "active" : ""}`}>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    toggleDropdown("funding");
                  }}
                  aria-haspopup="true"
                  aria-expanded={openDropdown === "funding"}
                >
                  Funding
                </a>

                <ul className={`sub-menu ${openDropdown === "funding" ? "active" : ""}`}>
                  <li><Link to="/funding/jumpstart" onClick={closeDropdowns}>Jumpstart</Link></li>
                  <li><Link to="/funding/boost" onClick={closeDropdowns}>Boost</Link></li>
                  <li><Link to="/funding/advisory" onClick={closeDropdowns}>Advisory</Link></li>
                </ul>
              </li>

              {/* ACCELERATOR */}
              <li className={`menu-item-has-children ${openDropdown === "accelerator" ? "active" : ""}`}>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    toggleDropdown("accelerator");
                  }}
                  aria-haspopup="true"
                  aria-expanded={openDropdown === "accelerator"}
                >
                  Accelerator
                </a>

                <ul className={`sub-menu ${openDropdown === "accelerator" ? "active" : ""}`}>
                  <li><Link to="/accelerator/dev-sprint" onClick={closeDropdowns}>Dev Sprint</Link></li>
                  <li><Link to="/accelerator/dev-build" onClick={closeDropdowns}>Dev Build</Link></li>
                  <li><Link to="/accelerator/dev-scale" onClick={closeDropdowns}>Dev Scale</Link></li>
                </ul>
              </li>
              <li>
                <Link to="/fundinglab" onClick={closeDropdowns}>Funding Lab</Link>
              </li>
              <li>
                <Link to="/portfolio" onClick={closeDropdowns}>Portfolio</Link>
              </li>
              <li>
                {/* <Link to="/innovation" onClick={closeDropdowns}>Innovation</Link> */}
              </li>
              <li>
                <Link to="/careers" onClick={closeDropdowns}>Careers</Link>
              </li>
              <li>
                <Link to="/contact" onClick={closeDropdowns}>Contact Us</Link>
              </li>
            </ul>
          </div>

          <div className="nav-right-part nav-right-part-desktop align-self-center">
            <Link
              className="btn btn-base-color border-radius-5 d-flex align-items-center"
              to="/apply"
              onClick={closeDropdowns}
            >
              Apply <FaArrowRight className="mt-0" />
            </Link>
          </div>
        </div>
      </nav>
    </>
  );
};

export default NavbarThree;
